import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Prop, Watch, Emit } from 'vue-property-decorator';
var ErrorDialog = /*#__PURE__*/function (_Vue) {
  function ErrorDialog() {
    var _this;
    _classCallCheck(this, ErrorDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ErrorDialog, [].concat(args));
    _defineProperty(_this, "visible", void 0);
    _defineProperty(_this, "title", void 0);
    _defineProperty(_this, "width", void 0);
    _defineProperty(_this, "closeOnOutsideClick", void 0);
    _defineProperty(_this, "showClose", void 0);
    _defineProperty(_this, "isVisible", false);
    return _this;
  }
  _inherits(ErrorDialog, _Vue);
  return _createClass(ErrorDialog, [{
    key: "mounted",
    value: function mounted() {
      this.isVisible = this.visible;
    }
  }, {
    key: "onVisiblePropChanges",
    value: function onVisiblePropChanges() {
      this.isVisible = this.visible;
    }
  }, {
    key: "handleDialogClose",
    value: function handleDialogClose() {
      this.isVisible = false;
      return true;
    }
  }]);
}(Vue);
export { ErrorDialog as default };
__decorate([Prop({
  default: false
})], ErrorDialog.prototype, "visible", void 0);
__decorate([Prop({
  default: ''
})], ErrorDialog.prototype, "title", void 0);
__decorate([Prop({
  default: '560px'
})], ErrorDialog.prototype, "width", void 0);
__decorate([Prop({
  default: true
})], ErrorDialog.prototype, "closeOnOutsideClick", void 0);
__decorate([Prop({
  default: true
})], ErrorDialog.prototype, "showClose", void 0);
__decorate([Watch('visible')], ErrorDialog.prototype, "onVisiblePropChanges", null);
__decorate([Emit("dialog-close")], ErrorDialog.prototype, "handleDialogClose", null);